import Vue from 'vue'
import Router from 'vue-router'




Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/processing-center',
      name: 'ProcessingCenter',
      component: () => import('../components/ProcessingCenter.vue')
    },
    {
      path: '/my-page',
      name: 'MyPage',
      component: () => import('../components/MyPage.vue')
    },
    {
      path: '/message-center',
      name: 'MessageCenter',
      component: () => import('../components/MessageCenter.vue')
    },
    {
      path: '/order-management',
      name: 'OrderManagement',
      component: () => import('../components/OrderManagement.vue')
    },
	{
	  path: '/',
	  redirect: '/processing-center'
	},
	{
	  path: '/Shou',
	  name: 'shou',
	  component: () => import('../components/Shou.vue')
	},
	{
	  path: '/Ver',
	  name: 'ver',
	  component: () => import('../components/Ver.vue')
	},
  ]
})
